import cn from 'classnames';

import allocateUrl from '@allocate/config/allocateUrl';
import BookDemoButton from '@/allocate/ui/common/BookDemoButton';
import GetStartedButtonComponent from '@framework/ui/Pages/Landing/Sections/GetStartedButton';
import { ButtonVariantType } from '@dealroadshow/uikit-button';

import styles from './startActions.module.scss';

const StartActions = () => (
  <div>
    <BookDemoButton
      className={ cn(styles.actionButton, styles.bookDemoButton) }
      variantType={ ButtonVariantType.outline as keyof typeof ButtonVariantType }
    />
    <span className={ styles.buttonsDivider }>or</span>
    <GetStartedButtonComponent
      title="Get Started"
      className={ cn(styles.actionButton, styles.getStartedButton) }
      url={ allocateUrl.getRegisterUrl() }
    />
  </div>
);

export default StartActions;
